import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer = (isPrivat: boolean): RadioAlternativ[] => [
    {
        id: isPrivat ? KategoriSvarId.AnsvarPrivatPersonskade : KategoriSvarId.AnsvarLandbrukNaringFormueskade,
        tekst: isPrivat ? 'Personskade' : 'Formueskade',
    },
    {
        id: isPrivat ? KategoriSvarId.AnsvarPrivatTingskade : KategoriSvarId.AnsvarLandbrukNaringTingskade,
        tekst: 'Tingskade',
    },
];

interface AnsvarUnderkategoriProps {
    isPrivat: boolean;
}

export const AnsvarUnderkategori: FC<AnsvarUnderkategoriProps> = ({ isPrivat }) => {
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (isPrivat) {
            if (svarId === KategoriSvarId.AnsvarPrivatPersonskade)
                navigate(skadeUrlFromSkadetype(Skademeldingstype.AnsvarPrivatPersonskade));
            else if (svarId === KategoriSvarId.AnsvarPrivatTingskade)
                navigate(skadeUrlFromSkadetype(Skademeldingstype.AnsvarPrivatTingskade));
        } else if (!isPrivat) {
            if (svarId === KategoriSvarId.AnsvarLandbrukNaringFormueskade)
                navigate(skadeUrlFromSkadetype(Skademeldingstype.AnsvarLandbrukNaringFormueskade));
            else if (svarId === KategoriSvarId.AnsvarLandbrukNaringTingskade)
                navigate(skadeUrlFromSkadetype(Skademeldingstype.AnsvarLandbrukNaringTingskade));
        }
    };

    return (
        <GruppeLandingsside
            title="Ansvar"
            svgCardType={SvgCardType.GruppeMennesker}
            onNext={onNext}
            navigateToParent={() => navigate(urler().ansvarUrl)}
            alternativer={alternativer(isPrivat)}
            radioButtonsLabel="Hva slags skade har oppstått?"
            kategoriId={isPrivat ? 'ansvar-privat' : 'ansvar-naring'}
        />
    );
};
